<div [@routerTransition]>
    <div class="kt-subheader kt-grid__item">
        <div class="kt-subheader__main">
            <h3 class="kt-subheader__title">
                <span>{{"Axilla.Webshop.FieldAgent.Customers" | localize}}</span>
            </h3>
            <span class="kt-subheader__separator kt-subheader__separator--v"></span>
            <span class="kt-subheader__desc">
                {{"Axilla.Webshop.FieldAgent.CustomersHeaderInfo" | localize}}
            </span>
        </div>
        <div class="kt-subheader__toolbar">
            <div class="kt-subheader__wrapper">
<!--                <button (click)="addNewManager()"-->
<!--                        [disabled]="!selectedCustomer"-->
<!--                        class="btn btn-primary">-->
<!--                    <i class="fa fa-plus"></i>-->
<!--                    {{"Axilla.Webshop.FieldAgent.Customer.AddManager" | localize}}</button>-->

                <button *ngIf="isGranted('Pages.Environment.Administration.Users.Create')"
                        (click)="createUser()"
                        class="btn btn-primary">
                    <i class="fa fa-plus"></i> {{"CreateNewCustomer" | localize}}</button>
            </div>
        </div>
    </div>

    <div class="kt-content">
        <div class="kt-portlet kt-portlet--mobile">

            <div class="kt-portlet__body p-4">
                <div class="customers-details-section">
                    <ng-container *ngIf="!selectedCustomer; else customerDetails">
                        <ng-container *ngTemplateOutlet="customersHeaderInfo"></ng-container>
                    </ng-container>

                    <ng-template #customerDetails>
                        <div class="details-content">
                            <h3 class="mb-4">{{ selectedCustomer.company }} - {{selectedCustomer.debitorNumber}}</h3>

                            <div class="d-flex p-">
                                <div class="customer-address-container">
                                    <h5 class="mb-3" (click)="editCustomer(selectedCustomer)">
                                        <strong>{{"Axilla.Webshop.FieldAgent.Customer.VisitorAddress" | localize}}</strong>
                                        <i class="fa fa-pencil-alt p-ml-1"></i>
                                    </h5>

                                    <p [ngClass]="{'mb-0': selectedCustomer?.visitorAddress}">
                                        <ng-container *ngIf="selectedCustomer?.visitorAddress">
                                            {{selectedCustomer?.visitorAddress}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!selectedCustomer?.visitorAddress"/>
                                    </p>

                                    <p [ngClass]="{'mb-0': selectedCustomer?.visitorAddress}">
                                        <ng-container *ngIf="selectedCustomer?.visitorCity">
                                            {{selectedCustomer?.visitorCity}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!selectedCustomer?.visitorCity"/>
                                    </p>
                                </div>
                                <p-divider layout="vertical"></p-divider>
                                <div>
                                    <h5 class="mb-3">
                                        <strong>{{"Axilla.Webshop.FieldAgent.Customer.SelectManagerToStart" | localize}}</strong>
                                    </h5>

                                    <div class="customer-users-container" *ngIf="isCustomerUsersAvailable; else noUsersBlock">
                                        <ng-container *ngFor="let user of customerShortUsersValue">
                                            <p-chip (click)="onManagerSelect(user)" label="{{user | fullName}}"></p-chip>
                                        </ng-container>

                                        <a href="javascript:void(0)"
                                           class="customers-link ml-4"
                                           (click)="addNewManager()">
                                            <i class="fa fa-plus"></i>
                                            {{"Axilla.Webshop.FieldAgent.Customer.AddManager" | localize}}
                                        </a>

                                        <a href="javascript:void(0)"
                                           class="customers-link ml-2"
                                           *ngIf="isShowViewAllManagers"
                                           (click)="viewAllCustomerUsers()">
                                            {{"Axilla.Webshop.FieldAgent.Customer.ViewAll" | localize}}
                                        </a>
                                    </div>

                                    <ng-template #noUsersBlock>
                                        <div class="d-flex p-align-center">
                                            <span>{{"Axilla.Webshop.FieldAgent.Customer.NoManagers" | localize}}</span>
                                            <p-divider layout="vertical"></p-divider>
                                            <a href="javascript:void(0)"
                                               class="customers-link"
                                               (click)="addNewManager()">
                                                <i class="fa fa-plus"></i>
                                                <span>
                                                    {{"Axilla.Webshop.FieldAgent.Customer.AddManager" | localize}}
                                                </span>
                                            </a>
                                        </div>

                                    </ng-template>
                                </div>
                            </div>


                        </div>
                    </ng-template>
                </div>

                <ng-template #customersHeaderInfo>
                    <div class="header-content">
                        {{"Axilla.Webshop.FieldAgent.Customer.SelectCustomerInfo" | localize}}
                    </div>
                </ng-template>
            </div>

            <div class="kt-portlet__body p-4">
                <form class="kt-form" autocomplete="new-password">
                    <div>
                        <div class="row align-items-center mb-4">
                            <div class="col-xl-12">
                                <div class="form-group m-form__group align-items-center">
                                    <div class="search-bar-container" [formGroup]="searchForm">
                                      <span class="p-input-icon-left">
                                            <i class="ml-3 pi pi-search"></i>

                                            <input
                                                type="text"
                                                pInputText
                                                autoFocus
                                                formControlName="filter"
                                                [placeholder]="l('SearchWithThreeDot')"
                                                class="pl-5 form-control search-input"/>

                                            <button *ngIf="!isFilterEmpty" (click)="clearInput()" class="clear-btn">
                                              <i class="pi pi-times"></i>
                                            </button>
                                      </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ng-container *ngIf="!hideAdvancedFilters">
                            <div class="row mb-4" *ngIf="advancedFiltersAreShown">
                                <div class="col-sm-12 text-right">
                                    <button class="btn btn-primary" (click)="getCustomers()"><i class="fa fa-sync"></i>
                                        {{"Refresh" | localize}}</button>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-sm-12">
                                <span class="clickable-item text-muted" *ngIf="!advancedFiltersAreShown"
                                      (click)="advancedFiltersAreShown=!advancedFiltersAreShown"><i
                                    class="fa fa-angle-down"></i> {{"ShowAdvancedFilters" | localize}}</span>
                                    <span class="clickable-item text-muted" *ngIf="advancedFiltersAreShown"
                                          (click)="advancedFiltersAreShown=!advancedFiltersAreShown"><i
                                        class="fa fa-angle-up"></i> {{"HideAdvancedFilters" | localize}}</span>
                                </div>
                            </div>
                        </ng-container>

                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-TurboTable-Start>-->
                    <div class="col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table #dataTable
                                 (onLazyLoad)="getCustomers($event)"
                                 [value]="primengTableHelper.records"
                                 rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                                 [paginator]="false"
                                 [lazy]="true"
                                 responsiveLayout="stack"

                                 selectionMode="single"
                                 [(selection)]="selectedCustomer"
                                 (onRowSelect)="onCustomerSelect($event)"
                                 (onRowUnselect)="onCustomerUnselect($event)"

                                 [breakpoint]="'768px'"
                                 [resizableColumns]="primengTableHelper.resizableColumns">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 150px">
                                        {{'Axilla.Webshop.FieldAgent.Customer.Name' | localize}}
<!--                                        <p-sortIcon field="name"></p-sortIcon>-->
                                    </th>
                                    <th style="width: 150px">
                                        {{'Axilla.Webshop.FieldAgent.Customer.Surname' | localize}}
<!--                                        <p-sortIcon field="surname"></p-sortIcon>-->
                                    </th>
                                    <th style="width: 150px">
                                        {{'Axilla.Webshop.FieldAgent.Customer.Company' | localize}}
<!--                                        <p-sortIcon field="username"></p-sortIcon>-->
                                    </th>

                                    <th style="width: 150px">
                                        {{'Axilla.Webshop.FieldAgent.Customer.City' | localize}}
<!--                                        <p-sortIcon field="username"></p-sortIcon>-->
                                    </th>
                                    <th style="width: 150px">
                                        {{'Axilla.Webshop.FieldAgent.Customer.Address' | localize}}
<!--                                        <p-sortIcon field="username"></p-sortIcon>-->
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit">
                                <tr [pSelectableRow]="record">
                                    <td style="width: 150px">
                                        <span class="p-column-title">
                                            {{'Axilla.Webshop.FieldAgent.Customer.Name' | localize}}
                                        </span>
                                        {{record?.firstName}}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">
                                            {{'Axilla.Webshop.FieldAgent.Customer.Surname' | localize}}
                                        </span>
                                        {{record?.surname}}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">
                                            {{'Axilla.Webshop.FieldAgent.Customer.Company' | localize}}
                                        </span>
                                        <ng-container *ngIf="record?.company">
                                            {{record?.company}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!record?.company"/>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">
                                            {{'Axilla.Webshop.FieldAgent.Customer.City' | localize}}
                                        </span>
                                        <ng-container *ngIf="record?.visitorCity">
                                            {{record?.visitorCity}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!record?.visitorCity"/>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">
                                            {{'Axilla.Webshop.FieldAgent.Customer.Address' | localize}}
                                        </span>
                                        <ng-container *ngIf="record?.visitorAddress">
                                            {{record?.visitorAddress}}
                                        </ng-container>
                                        <p-skeleton  class="no-animation" *ngIf="!record?.visitorAddress"/>
                                    </td>

                                </tr>
                            </ng-template>
                        </p-table>
                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            <span translation="Axilla.NoData" source="Axilla"></span>
                        </div>
                        <div class="primeng-paging-container">
                            <p-paginator #paginator
                                         [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                         (onPageChange)="getCustomers($event)"
                                         [totalRecords]="primengTableHelper.totalRecordsCount"
                                         [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage">
                            </p-paginator>
                            <span class="total-records-count total-absolute">
                                {{'TotalRecordsCount' | localize:primengTableHelper.totalRecordsCount}}
                            </span>
                        </div>
                    </div>
                    <!--<Primeng-TurboTable-End>-->
                </div>
            </div>
        </div>
    </div>
</div>


<editCustomerModal #editCustomerModal [options]="editCustomerOptions" (onSubmit)="onEditCustomer($event)"></editCustomerModal>
<viewAllManagersModal #viewAllManagersModal (onSelect)="onManagerSelect($event)"></viewAllManagersModal>
<addManagerModal #addManagerModal (onCreate)="onCreateManager($event)"></addManagerModal>

<createOrEditUserModal #createOrEditUserModal
                       [isCustomerMode]="true"
                       [billingInfoValidator]="billingInfoValidator"
                       (openSelectionOU)="openSelectOU($event)"
                       (modalSave)="getCustomers()"></createOrEditUserModal>
